export default __webpack_public_path__ + "static/media/japan_exam.dbf50d08.png";